/** DEV OPTS*/
/* @flow */
/* eslint-env node*/
/* eslint-disable no-console */
/*
 * Coach Amigo React STREAM
 * https://github.com/facebook/react-native
 *
 */

import _View from './View';
import _ResponsiveView from './ResponsiveView';
import _ScrollView from './ScrollView';
import _Text from './Text';
import _TextInput from './TextInput';
import _TinyPreloader from './TinyPreloader';
import _Touchable from './Touchable';
import _TouchableOpacity from './TouchableOpacity';
import _Image from './Image';
import _Icon from './../utils/Icon';
import _IconButton from './IconButton';
import _CenterButton from './CenterButton';
import _FlatList from './FlatList';
import _LinearGradient from './LinearGradient';

const _rem = (value: number): number => 500 * 0.02 * value;

export {
   _View as View,
   _ResponsiveView as ResponsiveView,
   _ScrollView as ScrollView,
   _Text as Text,
   _TextInput as TextInput,
   _TinyPreloader as TinyPreloader,
   _Touchable as Touchable,
   _TouchableOpacity as TouchableOpacity,
   _Image as Image,
   _Icon as Icon,
   _IconButton as IconButton,
   _CenterButton as CenterButton,
   _FlatList as FlatList,
   _LinearGradient as LinearGradient,
   _rem as rem
};
